import {KnowledgeTopicDto} from './knowledge-topic-dto';

export class KnowledgeDto {

  public id: string | null;

  public name: string | undefined;

  public topics: KnowledgeTopicDto[];

  public sectorId: string;

  public totalKnowledges: number = 0;

  constructor(id: string | null, name: string | undefined, topics: KnowledgeTopicDto[], sectorId: string) {
    this.id = id;
    this.name = name;
    this.topics = topics;
    this.sectorId = sectorId;
  }
}
